import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import WorkflowName from 'automation-ui-references/customer-data/WorkflowName';
import { PLATFORM } from 'automation-ui-flow-core/flow/FlowSourceTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EnrollInFlowActionExplainer({
  action,
  flowObjectTypeId
}) {
  const metadata = action.metadata;
  const {
    flowId
  } = metadata;
  return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "automation-ui-action-features.action-features.enroll-in-flow.explainer_cob",
    isJsx: true,
    objectTypeId: flowObjectTypeId,
    options: {
      flowName: /*#__PURE__*/_jsx(WorkflowName, {
        flowSourceType: PLATFORM,
        id: flowId
      })
    },
    elements: {
      Bold: 'strong'
    }
  });
}